module.exports = __webpack_public_path__ + "img/ATeilgroßaktiv.eadf1444.jpg";